import React from "react";
import NumberFormat from "react-number-format";
import { Chip, TextField } from "@mui/material";

export function sortList(list) {
  let listTemp = list
    .slice()
    .sort((first, second) => first.order - second.order);
  listTemp = listTemp.map((i, index) => {
    return { ...i, index: index };
  });
  return listTemp;
}

export function ListElement({ item: { id, title, index } }) {
  return (
    <Chip className={"DropListNew"} key={id} label={index + 1 + ". " + title} />
  );
}

export function MoneyField(props) {
  return (
    <NumberFormat
      customInput={TextField}
      prefix=""
      displayType="input"
      type="text"
      thousandSeparator={true}
      allowNegative={false}
      decimalScale={2}
      fixedDecimalScale
      {...props}
    />
  );
}

export function PhoneField(props) {
  return (
    <NumberFormat
      prefix=""
      displayType="input"
      type="tel"
      format={"(###) ###-####"}
      {...props}
    />
  );
}

export const LEASE_TERM_LENGTHS = {
  "Month To Month": [1, "month"],
  "6 Months": [6, "months"],
  "9 Months": [9, "months"],
  "1 Year": [1, "year"],
  "2 Years": [2, "years"],
  "3 Years": [3, "years"],
};

export const LEASE_TYPE_NOTES = {
  New: "New Lease: for a new tenant moving in. No bills are created on save. The security deposit and first month's rent are billed once all tenants have signed the lease.",
  Renewal: "Lease Renewal: for a tenant renewing in this unit. Enter the old and new security amounts; only the increase is added.",
  Existing: "Existing Lease: for a tenant already living in the unit under a lease signed earlier. No first month's rent is billed. Only the security deposit is recorded, once the lease is confirmed.",
};

export const toAmount = (value) => {
  const amount = parseFloat(String(value ?? "").replace(/,/g, ""));
  return isNaN(amount) ? 0 : amount;
};

export const formatMoney = (value) => {
  return "$" + toAmount(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
